import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
} from '@angular/core';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';

@Component({
  selector: 'app-premium-banner',
  templateUrl: './premium-banner.component.html',
  styleUrls: ['./premium-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumBannerComponent implements OnInit {
  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  @HostListener('click')
  onComponentClick() {
    this.onClick.emit();
  }

  premiumIconSize: IconSizesEnum;

  constructor() {}

  ngOnInit() {
    this.premiumIconSize = IconSizesEnum.small;
  }
}
